import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from "./style";
import { AppCard } from "component/shared/app-card";

interface Props extends WithStyles<typeof styles>{
	children?: React.ReactNode;
}

class Component extends React.Component<Props> {

	public render() {
		const { classes = {} } = this.props;
		return (
			<AppCard className={classes.card}>
				<Mui.CardContent className={classes.cardContent}>
					{this.props.children}
				</Mui.CardContent>
			</AppCard>
		);
	}
}


export const FullPageCard = withStyles(Component, styles);